import { useState } from 'react';
import { Button } from '@iwoca/orion';
import { Trans } from '@lingui/macro';
import clsx from 'clsx';
import { Logo } from 'components/Logo/Logo';
import { StagingBanner } from 'components/StagingBanner/StagingBanner';
import { useAmplitude } from 'hooks/useAmplitude';
import useWindowDimensions from 'hooks/useWindowDimensions';
import { BREAK_M } from 'utils/breakpoints';
import { getEnvironment } from 'utils/environmentHelper/environmentHelper';
import { AMPLITUDE_EVENTS } from 'utils/tracking/tracking.events';
import { HelpModal } from './Help/HelpModal';
import { LoginItem } from './LoginItem/LoginItem';
import styles from './Navigation.module.css';

export const LoggedOutNavigation = () => {
  const { trackEvent } = useAmplitude();
  const [showHelpModal, setShowHelpModal] = useState(false);
  const { width } = useWindowDimensions();

  const handleContactUsClick = () => {
    setShowHelpModal(true);
    trackEvent(AMPLITUDE_EVENTS.modalOpened, {
      'Modal name': 'Help modal',
    });
  };

  return (
    <div
      className={clsx(styles.navigationWrapper, {
        [styles.isStaging]: getEnvironment() === 'staging',
      })}
    >
      <StagingBanner />
      <nav className={styles.navigation} data-testid="navigation">
        <div className={styles.navItems}>
          <div className={clsx(styles.navItem, styles.loggedOutLogo)}>
            <Logo iconOnly={width <= BREAK_M} />
            <p className={styles.introducersLogoText}>
              <Trans>For Introducers</Trans>
            </p>
          </div>
        </div>
        <div className={styles.accountItems}>
          <div className={styles.accountItem}>
            <Button
              variant="tertiary"
              className={styles.navButton}
              onClick={handleContactUsClick}
            >
              <Trans>Contact us</Trans>
            </Button>
          </div>
          <LoginItem />
        </div>
      </nav>

      <HelpModal
        showModal={showHelpModal}
        closeModal={() => setShowHelpModal(false)}
      />
    </div>
  );
};
